import { render } from "./mainNav.vue?vue&type=template&id=fbbbe284&scoped=true"
import script from "./mainNav.vue?vue&type=script&lang=js"
export * from "./mainNav.vue?vue&type=script&lang=js"

import "./mainNav.vue?vue&type=style&index=0&id=fbbbe284&scoped=true&lang=css"

import exportComponent from "D:\\code\\csxlib-digital-resource\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbbe284"]])

export default __exports__